import { ReactElement, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { Input } from '../Input';
import { GoForwardButton } from '../HirePlanForm/GoForwardButton';
import axios from 'axios';
import Loading from '../icons/Loading';
import { Select } from '../Select';
import { changeProdutos, changeUFSigla } from '../../utils/ChangeArrays';
import { useOrcamentoForm } from '../../contexts/OrcamentoFormProvider';
import { PlanosForm } from './PlanejamentoForm/PlanosForm';
import { useProdutosOrcamentoStore } from '../../stores/useProdutosOrcamento';
import { getSiglaSeExistir } from '../../utils/getSiglaIfExists';
import { useBoostedPlanDataStore } from '../../stores/useBoostedPlanDataStore';
import { set } from 'date-fns';
import { validateCNPJ, validateCPF } from '../../utils/validations';

export function OrcamentoForm(): ReactElement {
  const { register, handleSubmit, watch, setValue, errors } =
    useOrcamentoForm();

  const parametro = watch('vendedor.parametro');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [mask, setMask] = useState('(99) 99999-9999');
  const planos = useProdutosOrcamentoStore(x => x.produtos);
  const setPlanos = useProdutosOrcamentoStore(x => x.setProdutos);
  const [ufs, setUfs] = useState([]);
  const cnpj = watch('empresa.cnpj');
  const cpf = watch('empresa.Responsavel.cpf');
  const Vendedor = useBoostedPlanDataStore(x => x.data);
  const setVendedor = useBoostedPlanDataStore(x => x.setBoostPlanData);
  const cep = watch('empresa.address.cep');
  const validaDados = async () => {
    setLoading(true);
    if (!parametro || parametro.length < 5) {
      alert('digite o código do vendedor ou um cpf do vendedor');
      setLoading(false);
      return;
    }
    const cleanParametro = parametro.replace(/[.\-_/]/g, '');
    const urlbase = process.env.REACT_APP_OG_API_URL;
    const dados = await axios.get(
      `${urlbase}/info/vendedor?parametro=${cleanParametro}`,
    );
    if (!dados || dados.status !== 200) {
      alert('Vendedor não encontrado...');
      setLoading(false);
      return;
    }
    setVendedor(dados.data.vendedor);
    changeProdutos(dados.data.produtos);
    await changeUFSigla(dados.data.ufs);
    setPlanos(dados.data.produtos);
    setUfs(dados.data.ufs);

    setValue('vendedor.name', dados.data.vendedor.tx_nome);
    setValue('vendedor.email', dados.data.vendedor.ds_email);
    setValue('vendedor.id_vendedor', dados.data.vendedor.id_vendedor);
    setValue(
      'vendedor.nu_cd_vendedor_s4_e',
      dados.data.vendedor.nu_cd_vendedor_s4_e,
    );

    setValue(
      'vendedor.id_corretora',
      dados.data.vendedor.Corretora.id_corretora,
    );
    setValue(
      'vendedor.nm_razao_social',
      dados.data.vendedor.Corretora.nm_razao_social,
    );

    changeUFSigla(dados.data.ufs);
  };

  useEffect(() => {
    if (cep && cep.length >= 8) {
      getCEPDetails(cep);
    }
  }, [cep]);

  const fetchEmpresa = async (cnpj: string) => {
    try {
      const dadosEmpresa = await axios.get(`https://api.opencnpj.org/${cnpj}`);
      if (dadosEmpresa.data) {
        setValue('empresa.razaoSocial', dadosEmpresa.data.razao_social);
      }
      console.log('dadosEmpresa: ', dadosEmpresa);
    } catch (error) {
      console.log('catch Error: ', error);
    }
  };
  const fetchCPF = async (cpf: string) => {
    try {
      const urlBase = process.env.REACT_APP_APICPF_URL;
      const token = process.env.REACT_APP_APICPF_KEY;
      const dadosCPF = await axios.get(`${urlBase}?cpf=${cpf}`, {
        headers: { 'X-API-KEY': token },
      });
      if (dadosCPF.data.code == 200) {
        setValue('empresa.Responsavel.nome', dadosCPF.data.data.nome);
      }
      console.log('dadosCPF: ', dadosCPF);
    } catch (error) {
      console.log('catch Error: ', error);
    }
  };

  useEffect(() => {
    if (cnpj) {
      const cnpjFormatado = cnpj?.replace(/\D/g, '');
      if (cnpjFormatado.length == 14) {
        const valido = validateCNPJ(cnpjFormatado);
        if (!valido) {
          alert('Cnpj Invalido;');
          setValue('empresa.cnpj', '');
          setValue('empresa.razaoSocial', '');
        } else {
          fetchEmpresa(cnpjFormatado);
        }
      }
    }
  }, [cnpj]);

  useEffect(() => {
    if (cpf) {
      const cpfFormatado = cpf?.replace(/\D/g, '');
      if (cpfFormatado.length == 11) {
        const valido = validateCPF(cpfFormatado);
        if (!valido) {
          alert('Cpf Invalido');
          setValue('empresa.Responsavel.cpf', '');
          setValue('empresa.Responsavel.nome', '');
        } else {
          fetchCPF(cpfFormatado);
        }
      }
    }
  }, [cpf]);

  const getCEPDetails = async (e: string) => {
    const formatedCep = e.replace(/[^0-9]/g, '');
    if (formatedCep.length < 8) {
      return;
    }
    const CEPInformations = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      {
        method: 'POST',
      },
    ).then(response => response.json());

    setLoading(false);
    if (CEPInformations.dados == null) {
      alert('cep não encontrado na Base');
      setValue('empresa.address.cep', '');
      setValue('empresa.address.city', '');
      setValue('empresa.address.neighborhood', '');
      setValue('empresa.address.street', '');
      setValue('empresa.address.uf', '');
      return;
    }
    const SiglaUf = getSiglaSeExistir(CEPInformations.dados.Uf);
    if (!SiglaUf) {
      alert('Não foi possivel encontrar a UF correspondente ao CEP informado');
      setValue('empresa.address.cep', '');
      setValue('empresa.address.city', '');
      setValue('empresa.address.neighborhood', '');
      setValue('empresa.address.street', '');
      setValue('empresa.address.uf', '');
      return;
    }
    setValue('empresa.address.city', CEPInformations.dados.Municipio);
    setValue('empresa.address.neighborhood', CEPInformations.dados.Bairro);
    setValue('empresa.address.street', CEPInformations.dados.Logradouro);
    setValue('empresa.address.uf', String(SiglaUf));

    return CEPInformations;
  };

  return (
    <section>
      <div className="bg-[#F8F8F8] px-8 flex items-center justify-between rounded-t-xl border-b border-b-primary-container">
        <form
          action=""
          className="w-full pb-32"
          /* onSubmit={handleSubmit(validaDados)} */
        >
          <h2 className="min-[748px]:text-xl text-lg text-primary-main mb-8 mt-8 text-center">
            Dados do Vendedor
          </h2>
          {Object.keys(Vendedor).length == 0 ? (
            <div className="grid min-[748px]:grid-cols-2 grid-cols-1 gap-6">
              <div className="max-[748px]:col-span-1">
                <Input
                  label="CPF ou Código do corretor"
                  placeholder="CPF ou Código do corretor"
                  errorMessage={errors.vendedor?.parametro?.message}
                  {...register('vendedor.parametro')}
                />
                {Object.keys(Vendedor).length == 0 && (
                  <GoForwardButton
                    tipo="button"
                    onForwardClick={validaDados}
                    Icon={loading ? Loading : undefined}
                    desktopText={loading ? '' : 'Pesquisar'}
                    mobileText={loading ? '' : 'Pesquisar'}
                  />
                )}
              </div>
            </div>
          ) : (
            <>
              <div className="grid min-[748px]:grid-cols-12 grid-cols-1 gap-6 mb-8">
                {/* <div className="col-span-3">
                  <span className="flex uppercase text-medium-emphasis text-xs font-normal gap-4">
                    <span className="block">Código Vendedor:</span>
                    <strong className="block text-neutral-600 normal-case text-sm ">
                      {Vendedor.id_vendedor}
                    </strong>
                  </span>
                </div> */}
                <div className="col-span-3">
                  <span className="flex uppercase text-medium-emphasis text-xs font-normal gap-4">
                    <span className="block">Código S4e Vendedor:</span>
                    <strong className="block text-neutral-600 normal-case text-sm text-primary-main">
                      {Vendedor.nu_cd_vendedor_s4_e}
                    </strong>
                  </span>
                </div>
                <div className="col-span-6">
                  <span className="flex uppercase text-medium-emphasis text-sm font-normal gap-4 ">
                    <span className="flex">Nome vendedor: </span>
                    <strong className="flex text-neutral-600 normal-case text-md text-primary-main">
                      {Vendedor.tx_nome}
                    </strong>
                  </span>
                </div>
                <div className="col-span-3">
                  <span className="flex uppercase text-medium-emphasis text-xs font-normal gap-4">
                    <span className="block">Código corretora:</span>
                    <strong className="block text-neutral-600 normal-case text-sm text-primary-main">
                      {Vendedor.Corretora.id_corretora}
                    </strong>
                  </span>
                </div>
                <div className="col-span-8">
                  <span className="flex uppercase text-medium-emphasis text-xs font-normal gap-4">
                    <span className="block">Nome corretora:</span>
                    <strong className="block text-neutral-600 normal-case text-sm text-primary-main">
                      {Vendedor.Corretora.nm_razao_social}
                    </strong>
                  </span>
                </div>
              </div>
              <div className="grid min-[748px]:grid-cols-12 grid-cols-1 gap-6">
                <div className="col-span-3">
                  <Input
                    label="E-mail do Vendedor"
                    placeholder="E-mail do Vendedor"
                    errorMessage={errors.vendedor?.email?.message}
                    {...register('vendedor.email')}
                  />
                </div>
              </div>

              <h2 className="min-[748px]:text-xl text-lg text-primary-main mb-8 mt-8 text-center">
                Dados da Empresa
              </h2>

              <div className="grid min-[748px]:grid-cols-12 grid-cols-1 gap-6">
                <div className="col-span-3">
                  <Input
                    label="Cnpj"
                    placeholder="Digite o Cnpj"
                    activateMask
                    mask="99.999.999/9999-99"
                    errorMessage={errors.empresa?.cnpj?.message}
                    {...register('empresa.cnpj')}
                  />
                </div>
                <div className="col-span-7">
                  <Input
                    label="Razão Social"
                    placeholder="Informe a Razão Social"
                    errorMessage={errors.empresa?.razaoSocial?.message}
                    {...register('empresa.razaoSocial')}
                  />
                </div>
              </div>
              <div className="grid min-[748px]:grid-cols-12 grid-cols-1 gap-6">
                <div className="col-span-3">
                  <Input
                    label="Cpf"
                    placeholder="Digite o Cpf do responsável pela empresa"
                    activateMask
                    mask="999.999.999-99"
                    errorMessage={errors.empresa?.Responsavel?.cpf?.message}
                    {...register('empresa.Responsavel.cpf')}
                  />
                </div>
                <div className="col-span-5">
                  <Input
                    label="Nome"
                    placeholder="Digite o Nome do Responsável pela empresa"
                    errorMessage={errors.empresa?.Responsavel?.nome?.message}
                    {...register('empresa.Responsavel.nome')}
                  />
                </div>
                <div className="col-span-4">
                  <Input
                    label="E-mail"
                    placeholder="Digite o Email do Responsável pela empresa"
                    errorMessage={errors.empresa?.Responsavel?.email?.message}
                    {...register('empresa.Responsavel.email')}
                  />
                </div>
                <div className="col-span-5">
                  <Input
                    label="Telefone"
                    placeholder="Digite o Telefone do Responsável pela empresa"
                    activateMask
                    mask={'(99) 99999-9999'}
                    errorMessage={
                      errors.empresa?.Responsavel?.telefone?.message
                    }
                    {...register('empresa.Responsavel.telefone')}
                  />
                </div>
              </div>
              <div className="grid grid-cols-4 gap-6">
                <div className="col-span-1">
                  <Input
                    activateMask
                    mask="99999-999"
                    label="CEP"
                    className="w-full"
                    placeholder="CEP"
                    errorMessage={errors.empresa?.address?.cep?.message}
                    {...register('empresa.address.cep')}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    label="Logradouro"
                    //value={street}
                    placeholder="Digite o seu logradouro"
                    errorMessage={errors.empresa?.address?.street?.message}
                    {...register('empresa.address.street')}
                  />
                </div>
                <Input
                  label="Número"
                  placeholder="Digite o seu número"
                  errorMessage={errors.empresa?.address?.number?.message}
                  {...register('empresa.address.number')}
                />
              </div>
              <div className="grid grid-cols-4 gap-6">
                <Input
                  label="Complemento"
                  placeholder="Digite o seu complemento"
                  errorMessage={errors.empresa?.address?.complement?.message}
                  {...register('empresa.address.complement')}
                />
                <Input
                  label="Bairro"
                  //value={neighborhood}
                  placeholder="Digite o seu bairro"
                  errorMessage={errors.empresa?.address?.neighborhood?.message}
                  {...register('empresa.address.neighborhood')}
                />
                <Input
                  label="Cidade"
                  //value={city}
                  placeholder="Digite sua cidade"
                  errorMessage={errors.empresa?.address?.city?.message}
                  {...register('empresa.address.city')}
                />
                <Select
                  label="UF"
                  options={[]}
                  optionsFull={ufs}
                  placeholder="UF"
                  errorMessage={errors.empresa?.address?.uf?.message}
                  {...register('empresa.address.uf')}
                />
              </div>

              <h2 className="min-[748px]:text-xl text-lg text-primary-main mb-8 mt-8 text-center">
                Orçamento
              </h2>

              <PlanosForm />
            </>
          )}

          {showError && (
            <div className="fixed top-24 left-1/2 transform -translate-x-1/5 bg-red-500 text-white py-2 px-4 rounded shadow-md">
              <p className="text-sm font-medium">
                {/* {error?.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))} */}
              </p>
            </div>
          )}
          {/* <GoForwardButton onForwardClick={validaDados} /> */}
        </form>
      </div>
    </section>
  );
}
/* function setUfs(ufs: any) {
  throw new Error('Function not implemented.');
} */
